import { round } from '../utils/number'

export function calculateRatePerDistance(rate: number, distance: number) {
  return round(rate / distance, 3)
}

export function calculateFlatRate(rate: number, distance: number) {
  return round(rate * distance, 2)
}
